import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/content";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="py-16 md:py-24 bg-background-100/60">
      <div className="px-4 md:px-8 max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-[380px_1fr] gap-8 lg:gap-14">
          <Reveal>
            <SectionHeading
              kicker="FAQ"
              title="关于红桃影视片单的常见问题"
              desc="把大家问得最多的几个问题整理在这里，帮你更快理解板块划分与评分、榜单的用法。"
            />
          </Reveal>

          <Reveal>
            <div className="flex flex-col gap-3">
              {faqs.map((item, i) => {
                const open = openIdx === i;
                return (
                  <div
                    key={item.q}
                    className={`bg-background-50 border rounded-xl overflow-hidden transition-colors ${
                      open ? "border-primary-300" : "border-background-200"
                    }`}
                  >
                    <h3>
                      <button
                        type="button"
                        onClick={() => setOpenIdx(open ? null : i)}
                        aria-expanded={open}
                        className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                      >
                        <span className="font-heading text-base font-semibold text-foreground-950">
                          {item.q}
                        </span>
                        <span
                          className={`shrink-0 w-7 h-7 rounded-full flex items-center justify-center transition-colors ${
                            open
                              ? "bg-primary-500 text-background-50"
                              : "bg-background-100 text-foreground-600"
                          }`}
                        >
                          <i
                            className={open ? "ri-subtract-line" : "ri-add-line"}
                            aria-hidden="true"
                          />
                        </span>
                      </button>
                    </h3>
                    <div
                      className={`grid transition-all duration-300 ease-out ${
                        open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                      }`}
                    >
                      <div className="overflow-hidden">
                        <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">
                          {item.a}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}